import { useAuth0 } from '@auth0/auth0-react'

export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    logout: auth0Logout,
    getAccessTokenSilently,
  } = useAuth0()

  const login = (opts) => loginWithRedirect(opts)

  const logout = () => {
    auth0Logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    getAccessTokenSilently,
  }
}
